module.exports = __webpack_public_path__ + "img/md-photo.7dac4f75.svg";